import { createContext } from 'react';
import { InboxLeadsContextProps } from './InboxLead.types';

// @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
const InboxLeadsContext = createContext<InboxLeadsContextProps>(undefined);

export default InboxLeadsContext;
